const SourceImg = {
    logoWeb: require('./web-logo.png'),
    coupon: require('./coupon.webp'),
    cashLogo: require('./paymethod/cash.webp'),
    visaLogo: require('./paymethod/visa.webp'),
    vnpayLogo: require('./paymethod/vnpay.webp'),
    mastercardLogo: require('./paymethod/mastercard.webp'),
    verifiedWebsite: require('./media/bo-cong-thuong.png'),
    // Slide
    slide2: require('./slide/img2.jpg'),
    slide1: require('./slide/img1.jpg'),
    //Banner
    bannerleft1: require('./banner/vertical/1.jpg'),
    bannerleft2: require('./banner/vertical/2.jpg'),
    goldRank: require('./profile/rank-gold.png'),
    sliverRank: require('./profile/rank-sliver.png'),
    copperRank: require('./profile/rank-copper.png'),
    defaultCover: require('./profile/default-cover.webp'),
    loveProduct: require('./profile/love-illustration.png'),
};
export default SourceImg;
